import React, { useEffect } from "react";
import {SignInContextProvider} from "./context/SignInContextProvider";
import {ErrorMessage, ErrorMessageForgotPassword, SuccessMessageForgotPassword} from "./components/ErrorMessage";
import {SignInContent} from "./components/SignInContent";
import {SignInPageLayout} from "./components/SignInPageLayout";

import {ForgotPasswordContextProvider} from "./context/ForgotPasswordContextProvider";
import {ForgotPasswordContent} from "./components/ForgotPasswordContent";

function isLowerEnvironment(): boolean {
    const domain = window.location.hostname;
    return domain.includes('dev.') || domain.includes('localhost') || domain.includes('127.0.0.1') || domain.includes('qa.');
}

function getRedirectUrl(): string | null {
    const domain = window.location.hostname;
    const params = new URLSearchParams(window.location.search);

    // Don't redirect if resume param is present (active sign-in flow)
    if (!params.has('resume') && !params.has('next') && !params.has('ssoCode')) {
        if (domain.includes('dev.custodysolutions')) {
            return 'https://dev.custodysolutions.site.gs.com/client-app/';
        } else if (domain.includes('qa.custodysolutions')) {
            return 'https://qa.custodysolutions.site.gs.com/client-app/';
        } else if (domain.includes('uat.custodysolutions')) {
            return 'https://uat.custodysolutions.gs.com/client-app/';
        } else if (domain.includes('custodysolutions.gs.com')) {
            return 'https://custodysolutions.gs.com/client-app/';
        } else if (domain.includes('advisorsolutions.')) {
            return 'https://' + domain + '/app';
        }
    }

    return null;
}

export function SignIn() {
    const redirectUrl = getRedirectUrl();

    useEffect(() => {
        if (redirectUrl) {
            window.location.href = redirectUrl;
        }
    }, [redirectUrl]);

    if (redirectUrl) {
        return null;
    }

    return (
        <SignInPageLayout showAgreement>
            <SignInContextProvider>
                <ErrorMessage/>
                <SignInContent/>
            </SignInContextProvider>
        </SignInPageLayout>
    );
}

export function ForgotPassword() {
    return (
        <SignInPageLayout showAgreement>
            <SignInContextProvider>
                <ForgotPasswordContextProvider>
                    <SuccessMessageForgotPassword/>
                    <ErrorMessageForgotPassword/>
                    <ForgotPasswordContent/>
                </ForgotPasswordContextProvider>
            </SignInContextProvider>
        </SignInPageLayout>
    );
}
